import React from 'react';
import { Modal, Button } from 'rsuite';

const AdminModal = ({ modalType, modalContent, isOpen, onClose }) => {
  return (
    <Modal show={isOpen} onHide={onClose} size="lg" className="text-left mw-100">
      <Modal.Header> 
      </Modal.Header>
      <Modal.Body>{modalContent}</Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose} appearance="subtle">
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AdminModal;